<template>
	<div class="main">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<span class="modal-title">{{!isEdit ? '新增' : '編輯'}}項目</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row form-group">
							<div class="col-md-8 form-group">
								<label for="year" class="col-sm-4 col-xs-2 column-required">名稱</label>
								<div class="col-sm-8 col-xs-10">
									<input id="name" name="name" v-model="form.name" v-validate="'required'" style="display: inline-block;"/>
									<span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
								</div>
							</div>
            </div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="handleSave">{{!isEdit ? '新增' : '儲存'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['data', 'isEdit', 'type'],
	data(){
		return {
			form: null,
      isCreateAnother: true
		}
	},
	beforeMount(){
		this.form = this.isEdit ?
      {
        name: this.data.commValue
      } :
      {
        name: ''
      };
	},
	methods:{
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
          if(this.data == null) {
            // 新增
            const api = `/api/room/createLeaveItem/${this.type}/${this.form.name}`;
            this.$axios.post(api, {}).then(resp => {
              bootbox.alert(resp.data.msg);
              if (resp.data.status === "success") {
                this.closePopup();
              }
            });
          } else {
            // 編輯
            const api = `/api/room/updateLeaveItem/${this.type}/${this.data.commCode}/${this.form.name}`;
            this.$axios.put(api, {}).then(resp => {
              bootbox.alert(resp.data.msg);
              if (resp.data.status === "success") {
                this.closePopup();
              }
            });
          }
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		},
		closePopup() {
			this.$parent.isOpenEditPopup = false;
      this.$parent.updateGrid();
		}
	}
}
</script>
